import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47bba313"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "campaign-page__header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "キャンペーン配信")
], -1))
const _hoisted_3 = { class: "campaign-page__chart" }
const _hoisted_4 = { class: "list-campaign-body mt-5 mb-8" }
const _hoisted_5 = {
  key: 0,
  class: "icon icon-campaign status-column"
}
const _hoisted_6 = {
  key: 1,
  class: "status-column"
}
const _hoisted_7 = {
  key: 2,
  class: "icon icon-campaign-done status-column"
}
const _hoisted_8 = {
  key: 3,
  class: "status-column"
}
const _hoisted_9 = { class: "grid w-full" }
const _hoisted_10 = { class: "col-5 grid" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, "配信数", -1))
const _hoisted_12 = {
  key: 0,
  class: "col-4"
}
const _hoisted_13 = {
  key: 1,
  class: "col-4"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, "開封数/率", -1))
const _hoisted_15 = {
  key: 2,
  class: "col-4"
}
const _hoisted_16 = {
  key: 3,
  class: "col-4"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, "クリック数/率", -1))
const _hoisted_18 = {
  key: 4,
  class: "col-4"
}
const _hoisted_19 = {
  key: 5,
  class: "col-4"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, "予約完了数/率", -1))
const _hoisted_21 = {
  key: 6,
  class: "col-4"
}
const _hoisted_22 = {
  key: 7,
  class: "col-4"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, "実来店/率", -1))
const _hoisted_24 = {
  key: 8,
  class: "col-4"
}
const _hoisted_25 = {
  key: 9,
  class: "col-4"
}
const _hoisted_26 = { class: "col-offset-1 col-6 grid" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, "CV成約合計額", -1))
const _hoisted_28 = {
  key: 0,
  class: "col-4"
}
const _hoisted_29 = {
  key: 1,
  class: "col-4"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, "CV成約平均単価", -1))
const _hoisted_31 = {
  key: 2,
  class: "col-4"
}
const _hoisted_32 = {
  key: 3,
  class: "col-4"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, "CV平均来店数", -1))
const _hoisted_34 = {
  key: 4,
  class: "col-4"
}
const _hoisted_35 = {
  key: 5,
  class: "col-4"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, " ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, " ", -1))

import { AxiosResponse } from "axios";
import { CampaignServices } from "@/clinic/services";
import { computed, onBeforeMount, ref } from "vue";
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import { get, set } from "@vueuse/core";
import { PageState } from "primevue/paginator";
import { useStore } from "vuex";
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import Header from "@/clinic/components/atoms/Grid/header.vue";
import LineChart from "../components/LineChart.vue";
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";
import RouterConstants from "../constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import type {
  ApiCampaignIndexReq,
  ApiCampaignIndexRes,
  ICampaign,
  ApiBasePaginatorReq,
  ICampaignChart,
  ApiCampaignBaseReq,
  ApiCampaignShowReq,
} from "@/clinic/typings";
import { notifySuccessMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'Campaign',
  setup(__props) {

const store = useStore();
const confirm = useConfirm();
const toast = useToast();

const loading = ref(true);
const channelId = ref(0);
const datasRsp = ref<ICampaign[]>([]);
const numberOfBookings = ref();
const numberOfImpression = ref();
const labels = ref();
const loadedDataChart = ref();
const columns = [
  { field: "id", header: "ID", class: "col-1" },
  { field: "name", header: "キャンペーン名" },
  { field: "start_date", header: "配信日時" },
  { field: "created_at", header: "更新日時" }, // use as updated_at field at the time waiting for confirmation
  { field: "segment_names", header: "セグメント名" },
  { field: "result", header: "配信結果", class: "col-4" },
  { field: "status", header: "配信状況" },
];
const first = ref(0);
const searchTerm = ref("");
const rows = ref(DEFAULT_PAGINATOR_ROWS);
const totalCount = ref(0);
const page = ref(0);
const pgTop = ref<InstanceType<typeof Paginator> | null>(null);
const pgBot = ref<InstanceType<typeof Paginator> | null>(null);

const paginatorParams = computed(
  (): ApiBasePaginatorReq => ({ term: get(searchTerm), page: get(page), rows: get(rows) } as ApiBasePaginatorReq)
);

const formatPercentage = (a: number, b: number) => {
  const calculate = (a / b) * 100;
  if (calculate % 2 !== 0) {
    return calculate.toFixed(2);
  } else {
    return calculate;
  }
};

const formatDateTime = (input: string): string => {
  const date = new Date(input);

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();

  const formattedDate = `${year}/${month}/${day}`;
  const formattedTime = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;

  return `${formattedDate} ${formattedTime}`;
};

/**
 *
 * Events
 */
const onRowClick = (_event: Event, { id }: ICampaign) => {
  RouterUtils.goToWithParams(RouterConstants.CAMPAIGN_RESULT_ROUTER_NAME, { id });
};

const newCampain = () => {
  RouterUtils.goToRouterPath(RouterConstants.CAMPAIGN_NEW_ROUTER_PATH);
};

const onSearch = async ({ currentTarget }: Event) => {
  set(searchTerm, currentTarget?.value);
  await loadCampaigns();
};

const paging = async (fromId: string, { page: newPage }: PageState) => {
  const pgRef = fromId == "pg-top" ? get(pgBot)?.getPagination() : get(pgTop)?.getPagination();
  if (newPage == pgRef?.page) return;

  get(pgRef)?.changePage(newPage);
  set(page, newPage);
  await loadCampaigns();
};

const loadCampaigns = async () => {
  const channelIdParam = async (): Promise<ApiCampaignIndexReq> => ({
    channel_id: await get(channelId),
  });
  set(loading, true);
  set(datasRsp, []);
  const { data } = (await CampaignServices.getCampaigns(
    { ...(await channelIdParam()), ...get(paginatorParams) } as ApiCampaignIndexReq,
    () => undefined,
    () => undefined,
    () => set(loading, false)
  )) as unknown as AxiosResponse<ApiCampaignIndexRes>;
  const { total_count } = get(data).meta;
  set(datasRsp, get(data).campaigns);
  set(totalCount, get(total_count));
};

const loadDataChart = async () => {
  const params: ApiCampaignBaseReq = {
    channel_id: get(channelId),
  };
  const { data } = await CampaignServices.getCampaignChart(params);
  const {
    number_of_bookings: numberOfBookingsData,
    number_of_impression: numberOfImpressionData,
    labels: labelsData,
  } = get(data) as unknown as ICampaignChart;
  set(numberOfBookings, get(numberOfBookingsData));
  set(numberOfImpression, get(numberOfImpressionData));
  set(labels, get(labelsData));
  set(loadedDataChart, true);
};

const handleChangeToDelivery = async (event, id) => {
  event.stopPropagation();
  const channelIdParam = async (): Promise<ApiCampaignIndexReq> => ({
    channel_id: await get(channelId),
  });
  confirm.require({
    message: "このキャンペーンを配信しますか?",
    header: "注意",
    rejectLabel: "キャンセル",
    acceptLabel: "登録",
    accept: async () => {
      await CampaignServices.deliverCampaign(
        { id, ...(await channelIdParam()) } as ApiCampaignShowReq,
        () => {
          const campaignIndex = get(datasRsp).findIndex(campaign => campaign.id == id);
          datasRsp.value[campaignIndex].status = "shipping";
          notifySuccessMsg(toast, "配信中");
        },
        (error: any) => notityErrorMsg(toast, error)
      );
    },
  });
};

onBeforeMount(async () => {
  set(channelId, await store.dispatch("authClient/getChannelIdCookie"));
  await loadCampaigns();
  await loadDataChart();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_unref(get)(loadedDataChart.value) == true)
        ? (_openBlock(), _createBlock(LineChart, {
            key: 0,
            loadedDataChart: _unref(get)(loadedDataChart.value),
            number_of_bookings: _unref(get)(numberOfBookings.value),
            labels: _unref(get)(labels.value),
            number_of_impression: _unref(get)(numberOfImpression.value)
          }, null, 8, ["loadedDataChart", "number_of_bookings", "labels", "number_of_impression"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Header, {
        enableSearch: "",
        onSearch: onSearch,
        onNew: newCampain,
        createButtonLabel: "新規作成",
        searchPlaceholder: "キャンペーン名"
      }),
      (totalCount.value > rows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 0,
            id: "pg-top",
            ref_key: "pgTop",
            ref: pgTop,
            modelValue: first.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((first).value = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value
          }, null, 8, ["modelValue", "totalRecords", "rows"]))
        : _createCommentVNode("", true),
      _createVNode(Grid, {
        items: datasRsp.value,
        columns: columns,
        onOnItemClick: onRowClick,
        loading: loading.value
      }, {
        start_date: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(formatDateTime(data.start_date)), 1)
        ]),
        created_at: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(formatDateTime(data.created_at)), 1)
        ]),
        status: _withCtx(({ data }) => [
          (data.status === 'shipping')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : (data.status === 'draft')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createVNode(_component_Button, {
                    class: "p-button-light",
                    label: "下書き",
                    onClick: ($event: any) => (handleChangeToDelivery($event, data.id))
                  }, null, 8, ["onClick"])
                ]))
              : (data.status === 'delivered')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                : (data.status === 'canceled')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "配信停止"))
                  : _createCommentVNode("", true)
        ]),
        result: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              (data.targets)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(data.targets), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, "-")),
              _hoisted_14,
              (data.number_of_impression && data.targets)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(data.number_of_impression) + "/" + _toDisplayString(_unref(get)(formatPercentage(data.number_of_impression, data.targets))) + "% ", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, "-")),
              _hoisted_17,
              (data.number_of_openings && data.targets)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(data.number_of_openings) + "/" + _toDisplayString(_unref(get)(formatPercentage(data.number_of_openings, data.targets))) + "% ", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, "-")),
              _hoisted_20,
              (data.number_of_bookings && data.targets)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(data.number_of_bookings) + "/" + _toDisplayString(_unref(get)(formatPercentage(data.number_of_bookings, data.targets))) + "% ", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, "-")),
              _hoisted_23,
              (data.number_of_visited && data.targets)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(data.number_of_visited) + "/" + _toDisplayString(_unref(get)(formatPercentage(data.number_of_visited, data.targets))) + "% ", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, "-"))
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              (data.number_of_completed_bookings)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(data.number_of_completed_bookings) + "人 ", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, "-")),
              _hoisted_30,
              (data.average_booking_price)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(data.average_booking_price), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_32, "-")),
              _hoisted_33,
              (data.average_visited)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(data.average_visited), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_35, "-")),
              _hoisted_36,
              _hoisted_37
            ])
          ])
        ]),
        _: 1
      }, 8, ["items", "loading"]),
      (totalCount.value > rows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 1,
            id: "pg-bot",
            ref_key: "pgBot",
            ref: pgBot,
            modelValue: first.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((first).value = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value,
            class: "mt-2"
          }, null, 8, ["modelValue", "totalRecords", "rows"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ]))
}
}

})